import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import UserCard from "./UserCard";
import ProjectNav from "./ProjectNav";

/**
 * 좌측 사이드바 컨테이너
 * UserCard(사용자 정보)와 ProjectNav(메뉴 트리)를 세로로 묶습니다.
 *
 * @param {object} me - 현재 로그인한 관리자 정보
 * @param {Function} onChangePassword - 비밀번호 변경 핸들러
 * @param {Function} onLogout - 로그아웃 핸들러
 * @param {string} currentView - 현재 선택된 뷰
 * @param {Function} onViewChange - 뷰 전환 핸들러
 */
const Sidebar = ({
  me,
  onChangePassword,
  onLogout,
  currentView,
  onViewChange,
  organizations,
  selectedProject,
  onProjectSelect,
}) => {
  return (
    <Box sx={{ width: 260, display: "flex", flexDirection: "column", gap: 2, flexShrink: 0 }}>
      {/* 앱 제목 */}
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        말랑 포켓 (관리자)
      </Typography>

      {/* 사용자 정보 카드 */}
      <UserCard
        me={me}
        onChangePassword={onChangePassword}
        onLogout={onLogout}
      />

      {/* 사업/메뉴 네비게이션 트리 */}
      <ProjectNav
        me={me}
        currentView={currentView}
        onViewChange={onViewChange}
        organizations={organizations}
        selectedProject={selectedProject}
        onProjectSelect={onProjectSelect}
      />
    </Box>
  );
};

export default Sidebar;
